/* global Promise */
/**
 * Fetch Script Function
 * @param {Source} source - URL of the script you want to fetch
 * @param {Callback} callback - fired once the script has loaded (optional)
 * @returns {Promise} - Promise that resolves when the script has loaded
 */
export default function fetchScript(source, callback) {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');

		script.onload = () => {
			if (callback) {
				callback();
			}
			resolve();
		};

		script.onerror = () => {
			reject(new Error(`Failed to load script: ${source}`));
		};

		script.src = source;
		document.body.appendChild(script);
	});
}
